import { render, staticRenderFns } from "./PromocionesCreator.vue?vue&type=template&id=c72b5a50&scoped=true"
import script from "./PromocionesCreator.vue?vue&type=script&lang=js"
export * from "./PromocionesCreator.vue?vue&type=script&lang=js"
import style0 from "./PromocionesCreator.vue?vue&type=style&index=0&id=c72b5a50&prod&scoped=true&lang=css"
import style1 from "./PromocionesCreator.vue?vue&type=style&index=1&id=c72b5a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72b5a50",
  null
  
)

export default component.exports